export default "__VITE_ASSET__jGQVlV11__"